var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-application',{key:_vm.key,attrs:{"type":_vm.CurrentMeta.Instance.Theme}},[_c('router-view',{staticClass:"router-view"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }